import NavbarAdmin from "./NavbarAdmin";

export default function OwnerNavbar(props) {
  return <NavbarAdmin {...props} />;
}
